import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";

const variantColors = {
  default: "#323232",
  success: "#4caf50",
  error: "#f44336",
  warning: "#ff9800",
  info: "#2196f3",
};

export const useNotifier = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return (message, variant = "default") => {
    enqueueSnackbar(message, {
      variant,
      autoHideDuration: 4000,
      action: (key) => (
        <IconButton
          onClick={() => closeSnackbar(key)}
          size="small"
          aria-label="cerrar"
          sx={{ color: "white" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ),
      ContentProps: {
        sx: {
          backgroundColor: variantColors[variant],
          color: "white",
          cursor: "pointer",
        },
      },
    });
  };
};
